import React, { useEffect, useState } from "react";
import CloseIcon from "../Assets/svgs/CloseIcon";
import { widgetLink } from "../Common/Constants";
import CopyIcon from "../Assets/svgs/CopyIcon";
import { useDispatch, useSelector } from "react-redux";
import { getWebsiteWidgetLink } from "../Redux/Slice/Assistant/WebsiteWidget/GetWebsiteWidgetLinkSlice";
import { Loader } from "../Common/Loader";
import { Tooltip } from "@mui/material";
import { copyToClipboard } from "../Common/utils";

const WidgetEmbeddedModal = ({ websites, onClose, assistantId }) => {
  const dispatch = useDispatch();
  const { widgetLinks, loading } = useSelector(
    (state) => state.websiteWidgetLinks
  );

  useEffect(() => {
    dispatch(getWebsiteWidgetLink(assistantId));
  }, [assistantId]);

  return loading ? (
    <Loader />
  ) : (
    <div className="modal modal--createAssistant modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--lg">
          <div className="modal__header ">
            <h1 className="modal__header--title">Embedded Codes</h1>
            <p className="para">
              Please use these embedded codes for integration.
            </p>
            <button className="btn btn__transparent btnClose" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body  modal-body-left">
            {Array.isArray(widgetLinks?.data)
              ? widgetLinks?.data?.map((websiteData) => (
                  <div className="formRow">
                    <div className="formCol">
                      <div className="form__Field">
                        <label
                          for="fieldType "
                          className="form__label form__label--medium"
                        >
                          Embedded Code ({websiteData?.website})
                        </label>
                        <div className="form__textarea form__textarea--embeddedCode">
                          {websiteData?.embedCode}
                        </div>
                      </div>
                      <CopyTooltipIcon text={websiteData?.embedCode} />
                    </div>
                  </div>
                ))
              : null}
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__white" onClick={onClose}>
                Cancel
              </button>
              <button className="btn btn__primary" onClick={onClose}>
                Ok, Got it
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

const CopyTooltipIcon = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [open,setOpen] = useState(false);

  const onClickCopy = () => {
    copyToClipboard(text);
    setIsCopied(true);
    setOpen(true);
    setTimeout(()=>{
      setOpen(false);
    },2000);
  };

  return (
    <p className="para para--right" onClick={onClickCopy}>
      <Tooltip title={isCopied ? "Copied" : "Copy"} placement="top" arrow open={open}>
        <button className="link link__primary">
          <CopyIcon />
          Copy Code
        </button>
      </Tooltip>
    </p>
  );
};

export default WidgetEmbeddedModal;
